module.exports = __webpack_public_path__ + "media/images/facilities/water-bottle-5d453c0ec1ea042c60da8fdc18bfedf2.png";